import { CUSTOM_ATTRIBUTE_VALUE_FRAGMENT } from "@gql/fragments/product/customAttributeValueFragment";
import gql from "graphql-tag";

// note - custom_attribute_value is a graphql alias configured in hasura for brevity
export const CUSTOM_ATTRIBUTE_VALUES_BY_ATTRIBUTE_ID = gql`
  query CustomAttributeValuesByAttributeId($attribute_id: String!, $user_id: String!) {
    custom_attribute_value(
      where: { attribute_id: { _eq: $attribute_id }, created_by_user_uid: { _eq: $user_id } }
    ) {
      ...customAttributeValueFields
    }
  }
  ${CUSTOM_ATTRIBUTE_VALUE_FRAGMENT}
`;
